import * as React from "react";

function SvgZoomIn(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" {...props}>
      <path
        d="M22.57 14.077h-2.831v5.662h-5.662v2.83h5.662v5.663h2.83V22.57h5.663v-2.831H22.57v-5.662z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.964 28.96a14.088 14.088 0 002.345-7.806C35.309 13.337 28.972 7 21.154 7 13.337 7 7 13.337 7 21.154c0 7.818 6.337 14.155 14.154 14.155 2.885 0 5.569-.863 7.806-2.345l7.207 7.207a2.83 2.83 0 104.004-4.004l-7.207-7.207zm-1.901-7.806c0 5.473-4.436 9.909-9.909 9.909-5.472 0-9.908-4.436-9.908-9.909 0-5.472 4.436-9.908 9.908-9.908 5.473 0 9.909 4.436 9.909 9.908z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgZoomIn;
